import axios from "axios";
import React, { useEffect, useState } from "react";
import { CiLocationOn, CiMail } from "react-icons/ci";
import { FaEye } from "react-icons/fa";
import { HiOutlineClipboard } from "react-icons/hi2";
import { PiPhoneCallLight } from "react-icons/pi";
import { Link } from "react-router-dom";

const SolutionHomeWork = () => {
  const [schoolClassName, setSchoolClassName] = useState("");
  const [reference, setReference] = useState("");
  const [allSubjects, setAllSubjects] = useState([]);
  const [subjectId, setSubjectId] = useState([]);
  const [studentClass, setStudentClass] = useState();

  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const [solutionCards, setSolutionCards] = useState([]);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/classes`)
      .then((resp) => {
        const { data } = resp.data;
        console.log(data);

        setSchoolClassName(data.slice(0, 8));
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/classes/${reference}`)
      .then((response) => {
        const { data } = response.data;
        setStudentClass(data.className);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [reference]);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/subjects/?reference=${reference}`)
      .then((result) => {
        const { data } = result.data;
        console.log(data);

        setAllSubjects(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [reference]);

  // homework/solution/:id

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/admin/homework/requests?subjectId=${subjectId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        console.log(response.data?.data);
        setSolutionCards(response.data?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [subjectId]);

  return (
    <>
      <div id="home-work-assistance-enquiry-main">
        <div className="ps-3 pb-3">
          <h1>
            <b>Home Work Solution</b>
          </h1>
          <div className="d-flex gap-2">
            <select
              className="select-dropdown"
              value={reference}
              onChange={(e) => setReference(e.target.value)}
              required
            >
              <option value="">-Select Class-</option>
              {schoolClassName &&
                schoolClassName.map((classes) => (
                  <option value={classes._id} key={classes._id}>
                    {classes?.className}
                  </option>
                ))}
            </select>
            <select
              className="select-dropdown"
              value={subjectId}
              onChange={(e) => setSubjectId(e.target.value)}
              required
            >
              <option value="">-Select Subject-</option>
              {allSubjects &&
                allSubjects.map((subject) => (
                  <option value={subject._id} key={subject._id}>
                    {subject?.subjectName}
                  </option>
                ))}
            </select>
          </div>
        </div>
        <div>
          {solutionCards &&
            solutionCards.map((item, idx) => (
              <div className="pb-2" key={idx}>
                {item.solution ? (
                  <div className="home-work-assitance-student-profile-container">
                    <div className="home-work-assitance-student-image-box">
                      <img
                        src={require("../../../../Images/student-profile-img.png")}
                        alt="student-img"
                      />
                    </div>

                    <div className="home-work-assistance-student-details-box">
                      <p className="student-name-b">
                        <b>{item.studentId.fullName}</b>
                      </p>

                      <p className="student-phone-and-email">
                        <span className="student-contact">
                          <PiPhoneCallLight className="icon-margin" />
                          {item.studentId.mobile}
                        </span>
                        <span className="student-email">
                          <CiMail className="icon-margin" />
                          {item.studentId.email}
                        </span>
                      </p>
                      <p className="student-address">
                        <CiLocationOn className="icon-margin" /> 3rd floor,
                        G-13,
                        {item.studentId.address} , {item.studentId.city} ,{" "}
                        {item.studentId.state} - {item.studentId.pinCode}
                      </p>
                      <p className="student-class-and-subject">
                        <span className="student-class">
                          <HiOutlineClipboard className="icon-margin" />
                          {studentClass}
                        </span>
                        {/* <span className="student-subjects">
                    <FiServer className="icon-margin" />
                    Maths, Physics
                  </span> */}
                      </p>
                      <p className="student-class-and-subject">
                        <span>Home Work Title : </span>
                        <span>{item.homeWorkTitle}</span>
                      </p>
                      <p className="student-class-and-subject">
                        <span>Language : </span>
                        <span>{item.language}</span>
                      </p>
                      <p>
                        <span>Teacher : </span>
                        <span>{item.teacherId.basicInfo?.fullName}</span>
                      </p>
                      <p>
                        <span>Teacher Contact : </span>
                        <span>{item.teacherId.basicInfo?.contactNumber}</span>
                      </p>
                      <p>
                        <span>Teacher Email: </span>
                        <span>{item.teacherId.basicInfo?.email}</span>
                      </p>
                      <p className="rejected-accepted-requests-and-forwards">
                        {/* <span
                      className="status"
                      // onClick={() => handleReject(item._id)}
                    >
                      Reject
                    </span>
                    <span
                      className="status"
                      // onClick={() => handleApprove(item._id)}
                    >
                      Reject
                    </span> */}

                        {item.solution ? (
                          <Link
                            to={`${API_BASE_URL}/uploads/${item.solution}`}
                            className="view-btn"
                            target="_blank"
                          >
                            <span className="view-btn p-2">
                              <FaEye
                                style={{
                                  marginRight: "5px",
                                  paddingTop: "2px",
                                }}
                              />
                              Solution View
                            </span>
                          </Link>
                        ) : null}

                        {/* <span className="add-user">
                      <Link
                        to={`/home-work-assistance/teacher-assign/${item._id}`}
                      >
                        <PiShareFatLight className="share-icon-btn icon-margin" />
                      </Link>
                    </span> */}
                      </p>
                    </div>
                  </div>
                ) : null}
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default SolutionHomeWork;
